import React from 'react';
import { Helmet } from 'react-helmet-async';
import { getImageUrl } from '../utils/imageUrl';

const SchemaMarkup = ({ product }) => {
  if (!product) return null;

  const baseUrl = window.location.origin;
  const productUrl = `${baseUrl}/product/${product._id}`;
  const imageUrl = getImageUrl(product.images?.[0] || product.image);

  // Calculate aggregate rating (you can fetch real ratings from backend)
  const aggregateRating = {
    ratingValue: product.rating || 4.5,
    reviewCount: product.reviewCount || 10,
  };

  // Determine availability
  const availability = product.stockCount > 0 
    ? 'https://schema.org/InStock' 
    : 'https://schema.org/OutOfStock';

  // Create Product Schema
  const productSchema = {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: product.name,
    image: imageUrl,
    description: product.description,
    brand: {
      '@type': 'Brand',
      name: 'IT World',
    },
    offers: {
      '@type': 'Offer',
      url: productUrl,
      priceCurrency: 'INR',
      price: product.basePrice,
      priceValidUntil: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0], // 30 days from now
      availability: availability,
      seller: {
        '@type': 'Organization',
        name: 'IT World',
      },
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: aggregateRating.ratingValue,
      reviewCount: aggregateRating.reviewCount,
    },
  };

  // Add category if available
  if (product.category) {
    productSchema.category = product.category;
  }

  // Add SKU if available
  if (product._id) {
    productSchema.sku = product._id;
  }

  // Create BreadcrumbList Schema
  const breadcrumbSchema = {
    '@context': 'https://schema.org/',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: baseUrl,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Products',
        item: `${baseUrl}/products`,
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: product.category || 'Category',
        item: `${baseUrl}/products?category=${encodeURIComponent(product.category || '')}`,
      },
      {
        '@type': 'ListItem',
        position: 4,
        name: product.name,
        item: productUrl,
      },
    ],
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(productSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
    </Helmet>
  );
};

export default SchemaMarkup;
